import React from 'react';
import { TbChevronDown } from 'react-icons/tb';

import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  ScrollPane,
} from '../../core-ui';
import { AppStatus, Status } from '../../core/constants/AppStatus';
import { StatusText } from './VendorStatus';

type Props = {
  onStatusSelect: (status: Status) => void;
};

export function BulkStatusChangeDropdown(props: Props) {
  const { onStatusSelect } = props;
  return (
    <Menu>
      <MenuButton as={Button} variant="ghost" rightIcon={<TbChevronDown />}>
        {t('Set Status')}
      </MenuButton>
      <Portal>
        <MenuList py={0}>
          <ScrollPane maxH="250px" contentContainerProps={{ py: 2 }}>
            {Object.keys(AppStatus).map((key) => (
              <MenuItem key={key} onClick={() => onStatusSelect(key)}>
                <StatusText status={AppStatus[key]} />
              </MenuItem>
            ))}
          </ScrollPane>
        </MenuList>
      </Portal>
    </Menu>
  );
}
